import { select, useSelection } from "lib/selection"
export {
    deselectProjectBridgeScheduleIds,
    getNextProjectBridgeScheduleSelection,
    selectProjectBridgeScheduleIds,
} from "./project-bridge-selection-presenters"

export const PROJECT_BRIDGE_SCHEDULE_SELECTION = "project-bridge-schedules"

export function useProjectBridgeScheduleSelection() {
    return useSelection(PROJECT_BRIDGE_SCHEDULE_SELECTION) || {}
}

export function setProjectBridgeScheduleSelection(selection) {
    return select(selection || {}, PROJECT_BRIDGE_SCHEDULE_SELECTION)
}

export function clearProjectBridgeScheduleSelection() {
    return setProjectBridgeScheduleSelection({})
}
